import type { ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface HeaderProps {
  children?: ReactNode;
  className?: string;
}

export const Header = ({ className, children }: HeaderProps) => (
  <div
    className={classNames(
      "text-dark border-primary sticky z-10 flex items-center justify-between border-b px-5 pb-2 pt-6 md:px-6 md:py-5",
      className,
      {
        "!p-0": window?.webview?.isInsideMobileWebview,
      },
    )}
  >
    <div className="flex w-full justify-between">{children}</div>
  </div>
);
